// extracted by mini-css-extract-plugin
export var avatar = "_nb-3";
export var avatarContainer = "_nb-2";
export var avatarSpacer = "_nb-5";
export var avatarSpacerContainer = "_nb-4";
export var avatarStackContainer = "_nb-1";
export var bubble = "_nb-0";
export var remainderBubble = "_nb-6";